// extracted by mini-css-extract-plugin
export default {"container":"List_container__m6+ex"};